import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ITopology } from '../../../../../app/apiSlice';
import { useState } from 'react';
import { setToast } from '../../../../../app/appSlice';
import { useDispatch } from 'react-redux';
import { useSavePipeline } from '../../../../../hooks/useSavePipeline';
import { NodeDefinitions } from '../../../editorSlice';
import { useTranslation } from 'react-i18next';

export const CreateVersion = ({topology, catalog, onDone}: { topology: ITopology, catalog: NodeDefinitions, onDone: () => any }) => {

    const { savePipeline } = useSavePipeline();
    const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);
    const [versionName, setVersionName] = useState('');
    const dispatch = useDispatch();
    const {t: translate} = useTranslation();

    const handleSubmit = async () => {
        const vName = versionName.trim() === '' ? 'default' : versionName;
        try {
            await savePipeline(topology, catalog, vName, true);
            dispatch(
                setToast({
                    title: translate('versions.new'),
                    severity: 'success',
                    content: translate('versions.new_done'),
                    life: 3000,
                })
            );
            onDone();
            setDialogVisibility(false);
        } catch {
            dispatch(
                setToast({
                    title: translate('versions.new'),
                    severity: 'error',
                    content: translate('versions.new_fail'),
                    life: 3000,
                })
            );
        }
    };

    const footerDialog = () => {
        return (
            <>
                <Button
                    label={translate('button.cancel')}
                    disabled={false}
                    onClick={() => {
                        setDialogVisibility(false)
                    }}
                    className="mr-3 p-button-outlined p-button-sm"
                />

                <Button
                    id="hook-form"
                    onClick={() => handleSubmit() }
                    type="submit"
                    label={translate('versions.new')}
                    className="p-button p-button-sm"
                />
            </>
        );
    };

    return (
        <>
            <Dialog
                header={translate('versions.new_create')}
                footer={footerDialog}
                draggable={false}
                style={{width: '25vw'}}
                visible={dialogVisibility}
                modal
                onHide={() => setDialogVisibility(false)}
            >
                <div className="field">
                    <label htmlFor="name"> {translate('versions.new_name')} </label>
                    <InputText className="w-full" onChange={(e) => setVersionName(e.target.value)} maxLength={42}/>
                </div>
            </Dialog>

            <Button
                className="p-button-text"
                icon="pi pi-plus"
                title={translate('versions.new_create')}
                onClick={() => {
                    setDialogVisibility(true);
                }}
            />
        </>
    );
};
